/**
 * useUserStats - Fetches user statistics from Firestore
 *
 * @param {Object} params
 * @param {string|null} params.userId - User ID to fetch stats for
 *
 * @returns {Object}
 * @returns {Object|null} stats - User statistics object
 * @returns {boolean} loading - Whether the fetch is in progress
 * @returns {Error|null} error - Any error that occurred during fetch
 */

import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

export const useUserStats = ({ userId }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Reset state when userId changes
    setStats(null);
    setLoading(true);
    setError(null);

    // Don't fetch if no userId
    if (!userId) {
      setLoading(true);
      return;
    }

    const fetchStats = async () => {
      try {
        const userStatsRef = doc(db, 'userStats', userId);
        const userStatsDoc = await getDoc(userStatsRef);

        if (userStatsDoc.exists()) {
          setStats(userStatsDoc.data());
        } else {
          setStats(null);
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching user stats:', err);
        setError(err);
        setStats(null);
        setLoading(false);
      }
    };

    fetchStats();
  }, [userId]);

  return {
    stats,
    loading,
    error
  };
};
